import type { PageInfo } from '../../../shared/types'
import { usePageProps } from '../../../shared/usePageProps'
import { getCampaignsPetitionSubVerticalDataLayer } from '../sub-vertical-variants/campaigns-petition/data-layer'
import { getCRTopicSubVerticalDataLayer } from '../sub-vertical-variants/cr-topic'
import { getHubSubVerticalDataLayer } from '../sub-vertical-variants/hub-page'
import { getNewsSubVerticalDataLayer } from '../sub-vertical-variants/news-sub-vertical'
import { getPolicyAndInsightLandingSubVerticalDataLayer } from '../sub-vertical-variants/policy-and-insight-landing/data-layer'
import { getReviewsSubVerticalDataLayer } from '../sub-vertical-variants/reviews-sub-vertical'

export const useSubVerticalPageDataLayer = () => {
  const { template } = usePageProps()

  return {
    getPageDatalayer(pageInfo: PageInfo) {
      switch (template) {
        case 'Subvertical':
          return getReviewsSubVerticalDataLayer(pageInfo)
        case 'CR Scams Topic':
        case 'CR Topic':
          return getCRTopicSubVerticalDataLayer(pageInfo)
        case 'News Category Listing':
          return getNewsSubVerticalDataLayer(pageInfo)
        case 'Hub Page':
          return getHubSubVerticalDataLayer(pageInfo)
        case 'Campaigns Petition':
          return getCampaignsPetitionSubVerticalDataLayer(pageInfo)
        case 'Policy and Insight Landing Page':
          return getPolicyAndInsightLandingSubVerticalDataLayer(pageInfo)
        default:
          return pageInfo
      }
    },
  }
}
